import { Notification, NotificationLineItem } from "@interfaces/notification";

export const decodeNotification = (
  notification: Notification
): NotificationLineItem => {
  return {
    id: notification.notification_id,
    projectId: notification.project_id,
    organisationId: notification.organisation_id,
    packageId: notification.package_id,
    message: notification.message,
    type: notification.type,
    created: notification.created,
  };
};

export const encodeNotification = (
  notification: NotificationLineItem
): Notification => {
  return {
    notification_id: notification.id,
    project_id: notification.projectId,
    organisation_id: notification.organisationId,
    package_id: notification.packageId,
    message: notification.message,
    type: notification.type,
    created: notification.created,
  };
};
